
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-item__meta").forEach(function (meta) {
    meta.addEventListener("click", function (e) {
      console.log("Button is CLicked");
      if (
        e.target.closest("button") ||
        e.target.closest("a")
      ) {
        return;
      }

      const productLink = meta
        .closest(".product-item")
        .querySelector(".product-item__image-link");

      if (productLink && productLink.href) {
        window.location.href = productLink.href;
      }
    });
  });
});

// ----- Custom JS for Swatch Images with Session Storage

// CUSTOM JS CODE FOR "LOW STOCK BADGE"

document.addEventListener("DOMContentLoaded", function () {
  function updateStock() {
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!variantInput) return;
    const variantId = variantInput.value;
    const stockEl = document.querySelector(
      '#variant-stock-data span[data-id="' + variantId + '"]'
    );
    const stockDiv = document.querySelector(".stock-display");
    if (!stockEl || !stockDiv) return;
    const stock = parseInt(stockEl.dataset.stock);
    if (stock > 0 && stock < 5) {
      stockDiv.innerHTML = "Low stock";
      stockDiv.style.display = "inline-block";
    } else {
      stockDiv.innerHTML = "";
      stockDiv.style.display = "none";
    }
  }

  // Page load
  updateStock();

  // Variant change (Stiletto safe)
  document.addEventListener("click", function () {
    setTimeout(updateStock, 100);
  });
});
